/** Sub-tabs of /management?tab=reward-credits, in display order. */
export const REWARD_SOURCES = [
  { id: 'appsumo', label: 'AppSumo reviews' },
  { id: 'producthunt', label: 'Product Hunt' },
  { id: 'onboarding', label: 'Onboarding calls' },
  { id: 'g2', label: 'G2' },
] as const;

export type RewardSource = (typeof REWARD_SOURCES)[number]['id'];

export const DEFAULT_REWARD_SOURCE: RewardSource = 'appsumo';

export const isRewardSource = (value: unknown): value is RewardSource =>
  REWARD_SOURCES.some((s) => s.id === value);

/** Tab ids the reward queues had before they merged into one section.
 *  Old bookmarks and shared links keep landing on the right queue. */
export const LEGACY_REWARD_TABS: Record<string, RewardSource> = {
  'review-credits': 'appsumo',
  'producthunt-credits': 'producthunt',
  'g2-credits': 'g2',
  'onboarding-call-credits': 'onboarding',
};
